<div class="fax-filter-list-wrapper">
  <div class="fax-filter-list-header">
    <button
      class="icon-btn icon-btn_sm"
      [class.fax-filter-list-expand-button_expanded]="isExpanded"
      (click)="toggleExpansion()"
    >
      <img
        src="assets/icons/chevron-left.svg"
        alt="Expand/collapse list"
        class="fax-filter-list-expand-button__icon"
      />
    </button>

    <img src="assets/icons/folder.svg" class="fax-filter-list-header-icon" />

    <h3 class="fax-filter-list-title">{{ title }}</h3>
  </div>

  <ul class="fax-filter-list" [class.fax-filter-list_expanded]="isExpanded">
    <ng-content></ng-content>
  </ul>
</div>
